import { Navigate, useParams } from "react-router-dom";
import { parseAssetId } from "../config/assets";
import { StakePage } from "./StakePage";

export const StakePageRoute = () => {
  const { asset } = useParams<{ asset: string }>();
  if (!parseAssetId(asset)) {
    return <Navigate to="/" replace />;
  }
  return <StakePage />;
};
